import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ComponentProps } from "react";
import styles from "./Dropdown.module.scss";

interface DropdownComposition {
  Root: typeof DropdownMenu.Root;
  Trigger: typeof Trigger;
  Content: typeof Content;
  Item: typeof Item;
}

const Dropdown: React.FC<ComponentProps<typeof DropdownMenu.Root>> &
  DropdownComposition = ({ children, ...rest }) => {
  return <DropdownMenu.Root {...rest}>{children}</DropdownMenu.Root>;
};
Dropdown.Root = Dropdown;

function Trigger({
  children,
  ...rest
}: ComponentProps<typeof DropdownMenu.Trigger>) {
  return (
    <DropdownMenu.Trigger asChild {...rest}>
      {children}
    </DropdownMenu.Trigger>
  );
}
Dropdown.Trigger = Trigger;

function Content({
  children,
  ...rest
}: ComponentProps<typeof DropdownMenu.Content>) {
  return (
    <DropdownMenu.Portal>
      <DropdownMenu.Content className={styles.content} align="end" {...rest}>
        {children}
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  );
}
Dropdown.Content = Content;

function Item({ children, ...rest }: ComponentProps<typeof DropdownMenu.Item>) {
  return (
    <DropdownMenu.Item className={styles.item} {...rest}>
      {children}
    </DropdownMenu.Item>
  );
}
Dropdown.Item = Item;

export default Dropdown;
